import React from "react";
import { motion } from "framer-motion";

const REVEAL_VIEWPORT = { once: true, margin: "-60px" };

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] } }),
};

export const Reveal = ({ children, i = 0, className = "" }) => (
  <motion.div variants={fadeUp} custom={i} initial="hidden" whileInView="show" viewport={REVEAL_VIEWPORT} className={className}>
    {children}
  </motion.div>
);

export const Btn = ({ children, href, variant = "primary", className = "", ...props }) => {
  const base = "inline-flex items-center justify-center gap-2 rounded-full font-medium transition-all duration-300 ease-out focus:outline-none focus:ring-2 focus:ring-afwn-green focus:ring-offset-2 focus:ring-offset-afwn-bg";
  const styles = {
    primary: "bg-afwn-green text-white hover:bg-afwn-greenDark hover:scale-[1.03] px-8 py-4 text-base shadow-lg shadow-afwn-green/20",
    ghost: "bg-white/70 backdrop-blur border border-afwn-navy/10 text-afwn-navy hover:bg-white px-6 py-3 text-base",
    amber: "bg-afwn-amber text-white hover:brightness-95 hover:scale-[1.03] px-8 py-4 text-base shadow-lg shadow-afwn-amber/20",
  };
  const ext = typeof href === "string" && href.startsWith("http") ? { target: "_blank", rel: "noopener noreferrer" } : {};
  return (
    <a href={href} className={`${base} ${styles[variant]} ${className}`} {...ext} {...props}>{children}</a>
  );
};

export const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
